<template>
  <f-form
      store="@freebe/users"
      :id="userId"
    >
      <template #default="{ item }">
        <div class="is-grid">
          <f-field 
            class="is-col-6"
            label="Email"
          >
            <f-input 
              v-model="item.email"
              suffix-icon="envelope"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-3"
            label="Prénom"
          >
            <f-input 
              v-model="item.firstname"
              suffix-icon="user"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-3"
            label="Nom"
          >
            <f-input 
              v-model="item.lastname"
              suffix-icon="user"
              :readonly="!canEdit"
            ></f-input>
          </f-field>

          <f-field 
            class="is-col-3"
            label="Abonné jusqu'au"
          >
            <f-datepicker 
              v-model="item.allowed_until"
              readonly
            ></f-datepicker>
          </f-field>

          <div class="is-col-12">
            <hr>
          </div>

          <f-field 
            class="is-col-3 is-aligned"
            :label="item.isVerified ? `Le compte est vérifié` : `Valider le compte`"
            :readonly="!canEdit"
            inline
          >
            <f-toggle 
              v-model="item.isVerified"
              :disabled="item.isVerified"
              :readonly="!canEdit"
            ></f-toggle>
          </f-field>
        </div>
      </template>
    </f-form>
</template>

<script>
  import { computed, ref } from 'vue'
  import { useStore } from '@freebe/sdk/store'
  import router from '@core/router'
  import useRoles from '@composables/use-roles'

  export default {
    props: {
      id: {
        type: String, 
        required: true,
      },
    },

    setup (props) {
      const { checkPermissions } = useRoles()
      
      const canEdit = computed(() => 
        checkPermissions('freebe/users:patch')
      )

      const userId = ref(props.id)
      
      return {
        userId,
        canEdit,
      }
    } 
  }
</script>